<template>
  <span>
    <a
      :href="href"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ text }}
      <img
        :src="`${publicPath}img/external-link.svg`"
        alt="goes to external website"
      >
    </a>
  </span>
</template>

<script>
export default {
  props: {
    text: { type: String, required: true },
    href: { type: String, required: true },
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
};

</script>
